var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlack4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1_-_ARTWORK_-_SILVER_FLAT",
    "data-name": "1 - ARTWORK - SILVER FLAT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.31 8.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Style-graphique-6{fill:#13113d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Style-graphique-6",
    d: "M.15,3.05l1.2,4.17-.13-.13A4.14,4.14,0,0,1,.15,3.05ZM7.09,1.22h0A4.16,4.16,0,0,0,3,.16L7.25,1.39A1.29,1.29,0,0,0,7.09,1.22Zm1,1.63L6.44,3,4,3.27l2.3,2.3L7.42,6.72A4.11,4.11,0,0,0,8.1,2.85ZM3.25,4,2.83,8.09a4.12,4.12,0,0,0,3.86-.64L5.54,6.29Zm-.4-1.66a.38.38,0,0,0,.15,0l2.83-.29L1.64.85a2.93,2.93,0,0,0-.42.37,3.39,3.39,0,0,0-.4.45L2,5.86l.29-2.8a1.21,1.21,0,0,0,0-.19h0a.53.53,0,0,1,.15-.37A.54.54,0,0,1,2.85,2.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack4);
export default __webpack_public_path__ + "static/media/black4.59313be611971b412f2214abee24058a.svg";
export { ForwardRef as ReactComponent };